import { provideHttpClient, withInterceptors } from '@angular/common/http';
import {
  importProvidersFrom,
  type ApplicationConfig,
  provideBrowserGlobalErrorListeners,
  DOCUMENT,
} from '@angular/core';
import { OverlayModule } from '@angular/cdk/overlay';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter } from '@angular/router';
import { provideServiceWorker } from '@angular/service-worker';
import { customerAuthorizationInterceptor } from './core/auth/customer-authorization.interceptor';
import { appRoutes } from './app.routes';
import { AuthSessionService } from './core/auth/auth-session.service';
import { WISHLIST_READ_CONTEXT } from '@nexus/customer/wishlists/data-access';
import { WISHLIST_RESERVATION_TERMS_URL } from '@nexus/customer/wishlists/ui';
import { resolveReservationQaTermsUrl } from './core/wishlists/functions/resolve-reservation-qa-terms-url/resolve-reservation-qa-terms-url';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    { provide: WISHLIST_READ_CONTEXT, useFactory: (auth: AuthSessionService) => auth.meContext, deps: [AuthSessionService] },
    {
      provide: WISHLIST_RESERVATION_TERMS_URL,
      useFactory: (document: Document): string | null => resolveReservationQaTermsUrl(
        document.location.origin,
        document.defaultView?.__NEXUS_WEB_CONFIG__?.environment,
        document.defaultView?.__NEXUS_WEB_CONFIG__?.reservationQaTermsUrl,
      ),
      deps: [DOCUMENT],
    },
    provideAnimationsAsync(),
    importProvidersFrom(OverlayModule),
    provideHttpClient(withInterceptors([customerAuthorizationInterceptor])),
    provideRouter(appRoutes),
    provideServiceWorker('ngsw-worker.js', {
      enabled: true,
      registrationStrategy: 'registerWhenStable:30000',
    }),
  ],
};
